export const secretaryToFormTransformer = secretary => {
    if (!secretary) {
        return null;
    }
    return {
        ...secretary,
        qualification: secretary.qualification ? secretary.qualification.id : null,
    };
}
